import { mapState } from "vuex";
import { Loading } from "element-ui";
import logistics_dtl from "@/views/order/module/logisticsInfo";
import order_basic_info_dtl from "@/views/order/module/orderBasicInfo";
import order_pay_info_dtl from "@/views/order/module/orderPayInfo";
import order_info_dtl from "@/views/order/module/orderInfo";
import order_goods_info_dtl from "@/views/order/module/orderGoodsInfo";
import buyer_dialog from "@/views/order/orderDialog/order";
import contract_sign from "@/views/order/orderDialog/contractSign.vue";
import QrCode from "qrcode";
import { uuid, isMobile } from "@/utils/utils";
import requestApi from "@/utils/requestApi";
import bestsign from "@/views/treaty/bestsign_content.vue";
import { getUser } from "@/api/app";
import contractPreview from "@/components/contractPreview/contractPreview.vue";
import { preOrdergenerate } from "@/views/order/common.js";

const { VUE_APP_APP } = process.env;

let loading = null;
let imgTransferTimer = null;
let uuidStr = 0;

export default {
  components: {
    bestsign,
    logistics_dtl,
    buyer_dialog,
    order_info_dtl,
    order_goods_info_dtl,
    order_pay_info_dtl,
    order_basic_info_dtl,
    contract_sign,
    contractPreview,
  },

  data() {
    const checkLicensePlate = (rule, value, callback) => {
      if (value) {
        // eslint-disable-next-line
        const reg =
          // eslint-disable-next-line max-len
          /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$)|([0-9]{4,5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4,5}$))/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的车牌号"));
        }
      }
    };
    const checkIdCard = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      // eslint-disable-next-line
      const reg18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      const reg15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      if (reg18.test(value) || reg15.test(value)) {
        callback();
      } else {
        return callback(new Error("请输入正确的身份证号"));
      }
    };
    return {
      loaded: false,
      env: process.env,
      orderId: "",
      detail: {
        orderTransportDtlBo: {
          linkman: "",
        },
        orderDtlBo: {
          orderInvoice: {},
        },
      },
      buttonList: [],
      orderDelivery: [],
      orderGoodsList: [],
      orderGoodsGiftBoList: [],
      buyerVoucherPicList: [],
      buyerCfyVoucherPicList: [],
      cfyCard: 0,
      checkCartDialogVisible: false,
      addCartDialogVisible: false,
      vehicleAddDialogVisible: false,
      orderVehicleList: [],
      addCartList: [],
      vehicleForm: {
        name: "",
        tel: "",
        licensePlateNum: "",
        idCard: "",
      },
      vehicleRules: {
        name: [{ required: true, message: "请填写车主姓名", trigger: "blur" }],
        tel: [{ required: true, message: "请填写车主联系方式", trigger: "blur" }],
        licensePlateNum: [
          { required: true, message: "请输入车牌号", trigger: "blur" },
          { validator: checkLicensePlate, trigger: "blur" },
        ],
        idCard: [{ validator: checkIdCard, trigger: "blur" }],
      },
      thisVehicleChangeId: "",

      editOrderSnapshotDialogVisible: false,

      smsVisible: false,

      deliveryDialogVisible: false,
      deliveryGoodsButton: {},
      signatureDialogVisible: false,
      submitBuyerVoucherLoading: false,
      reqTimestamp: "",
      reqSystemId: "",
      accessToken: "",
      dataMasking: "",
      // 订单凭证记录
      orderCredential: {},
      // 订单凭证记录
      orderCredentialList: [],
      // 审核通过凭证列表
      auditCredentialImgList: [],
      // 发票
      dialogFormVisible: false,
      // 发票嘻嘻
      form: {
        issueType: "ZZ",
        type: "PTFP",
        invoicetitleType: "GR",
        name: "",
        tel: "",
        code: "",
        addr: "",
        bankName: "",
        bankCode: "",
        nameDisabled: false,
      },
      // 个人发票校验
      rules: {
        name: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入税号",
            trigger: "blur",
          },
        ],
      },
      // 增值税发票校验
      rulesInvoiceType: {
        name: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入税号",
            trigger: "blur",
          },
        ],
        addr: [
          {
            required: true,
            message: "请输入企业地址",
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            message: "请输入企业电话",
            trigger: "blur",
          },
        ],
        bankName: [
          {
            required: true,
            message: "请输入开户银行",
            trigger: "blur",
          },
        ],
        bankCode: [
          {
            required: true,
            message: "请输入银行账号",
            trigger: "blur",
          },
        ],
      },
      // 企业发票校验
      rulesInvoiceQyType: {
        name: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入税号",
            trigger: "blur",
          },
        ],
        // addr: [
        //   {
        //     required: true,
        //     message: "请输入企业地址",
        //     trigger: "blur",
        //   },
        // ],
        // tel: [
        //   {
        //     required: true,
        //     message: "请输入企业电话",
        //     trigger: "blur",
        //   },
        // ],
      },
      // 总的发票校验
      invoiceRule: {
        name: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入税号",
            trigger: "blur",
          },
        ],
      },
      viewShow: false,
      titleShow: true,
      formRef: {},
      // 是否支持增值税发票
      isZzInvoice: "0",
      // 开票：0: 不需要签约，1：代付协议，2：权利义务转让协议
      contractType: 0,
      // 开票：协议名称
      contractName: "",
      // 企业地址提示
      invoiceQyAddrTip: "选填",
      // 企业电话
      invoiceQyTelTip: "选填",
      // 开户银行
      invoiceQyBankTip: "选填",
      // 银行账号
      invoiceQyBankNoTip: "选填",
      checked: true,
      basicCaAgreementUrl: "",
      basicCaAgreementName: "",
      basicCaChecked: false,
      basicCaIsAuthFile: false,
      basicCaAuthFileDialogVisible: false,
      basicCaAuthFileTemplateUrl: "https://nfs.nxin.com/cxt/CA_Authorization2606.docx",
      invoiceContractType: "",
      agreementVisible: false,
      showAddInvoice: false,
      notCheckInvoiceBtnTips: "",
      bestsignContentVisible: false,
      // 接口返回发票信息
      invoiceInfo: {},
      invoiceOnLine: false,

      contractPreviewUrl: "",
      contractPreviewVisible: false,

      vehicleListCollapse: false,
      // 是否展示查看合同
      showContractButton: false,
      // 预订单入库通知操作记录
      noticeOperationRecord: null,
      // 预订单入库验收操作记录
      acceptanceOperationRecord: null,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo,
    }),
    /**
     * 是否展示预订单入库通知/验收模块
     *
     * @Auther SongYapeng
     * @Date 2026/6/11
     */
    showPreOrderInboundInfo() {
      return !!(this.noticeOperationRecord || this.acceptanceOperationRecord);
    },
    showInvoiceContractAgreement() {
      return (
        !!this.invoiceContractType &&
        (this.form.invoicetitleType === "QY" || this.form.type === "ZZSZYFP")
      );
    },
    showBasicCaAgreement() {
      return !!this.basicCaAgreementUrl && this.showInvoiceContractAgreement;
    },
    invoiceSaveEnabled() {
      if (this.showBasicCaAgreement && !this.basicCaChecked) {
        return false;
      }
      if (this.showInvoiceContractAgreement && !this.checked) {
        return false;
      }
      return true;
    },
    invoiceSaveDisabledTips() {
      if (this.showBasicCaAgreement && !this.basicCaChecked) {
        return `请勾选同意《${this.basicCaAgreementName}》`;
      }
      if (this.showInvoiceContractAgreement && !this.checked) {
        return this.notCheckInvoiceBtnTips || `请勾选同意${this.contractName}`;
      }
      return "";
    },
  },
  created() {
    this.orderId = this.$route.params.id || 0;
    const { timestamp, systemId, accessToken, dataMasking, showAddInvoice } = this.$route.query;
    this.showAddInvoice = showAddInvoice && showAddInvoice === "true";
    if (isMobile()) {
      if (window.location.pathname.indexOf("/api/order/detail/") !== -1) {
        window.location.href = `${VUE_APP_APP}vm2/order/buyer/orderDetailView/index?orderId=${this.orderId}&timestamp=${timestamp}&systemId=${systemId}&accessToken=${accessToken}`;
        return;
      }
      window.location.href = `${VUE_APP_APP}vm2/order/buyer/orderDetail/index?orderId=${this.orderId}&timestamp=${timestamp}&systemId=${systemId}&accessToken=${accessToken}`;
      return;
    }
    this.reqTimestamp = timestamp || "";
    this.reqSystemId = systemId || "";
    this.accessToken = accessToken || "";
    this.dataMasking = dataMasking || "";
    this.queryOrderDetail();
  },
  watch: {
    signatureDialogVisible(val) {
      if (!val) {
        imgTransferTimer && clearInterval(imgTransferTimer);
        uuidStr = 0;
      }
    },
  },
  methods: {
    readBestsign() {
      this.bestsignContentVisible = true;
    },
    async fetchBasicCaAgreement() {
      this.basicCaAgreementUrl = "";
      this.basicCaAgreementName = "";
      this.basicCaChecked = false;
      this.basicCaIsAuthFile = false;
      this.basicCaAuthFileDialogVisible = false;
      const { code, data } = await requestApi.post("sctrading/contract/getBasicCa", {
        returnUrl: window.location.href,
      });
      if (code == "0" && data && data.url) {
        this.basicCaAgreementUrl = data.url;
        this.basicCaAgreementName = data.name || "";
        this.basicCaIsAuthFile = !!data.isAuthFile;
      }
    },
    openBasicCaAgreement() {
      if (!this.basicCaAgreementUrl) {
        return;
      }
      if (this.basicCaIsAuthFile) {
        this.basicCaAuthFileDialogVisible = true;
        return;
      }
      window.location.href = this.basicCaAgreementUrl;
    },
    onBasicCaAuthFileReady() {
      this.basicCaAuthFileDialogVisible = false;
      window.location.href = this.basicCaAgreementUrl;
    },
    onBasicCaAuthFileCancel() {
      this.basicCaAuthFileDialogVisible = false;
      this.basicCaChecked = false;
    },
    onBasicCaCheckedChange(val) {
      if (val) {
        this.openBasicCaAgreement();
      }
    },
    // 合同预览
    previewAgreement() {
      // 需要签署合同，但是未实名
      if (this.invoiceContractType && (this.form.invoicetitleType === "QY" || this.form.type === "ZZSZYFP") && !this.detail.payMemberAuthStatus) {
        this.$confirm("用户未认证无法完成签署", "提示", {
          confirmButtonText: "去认证",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            window.open(`${process.env.VUE_APP_JR}v/accountAsset/balance/entBindCard?retUrl=${window.location.href}`);
          })
          .catch(() => {});
        loading.close();
        return;
      }
      const loading = this.$loading({
        lock: false,
        text: "加载中...",
      });
      let orderInvoice = {
        issueType: this.form.issueType,
        receipt: this.form.name,
        type: this.form.type,
        invoicetitleType: this.form.invoicetitleType,
        taxRegistrationNumber: this.form.code,
        bankAccount: this.form.bankCode,
        bankOfDeposit: this.form.bankName,
        companyAddr: this.form.addr,
        companyTel: this.form.tel,
      };
      // 查询开票等设置
      this.$store
        .dispatch("orderTo/index/previewAgreement", {
          orderId: this.orderId,
          invoiceContractType: this.invoiceContractType,
          orderInvoice: orderInvoice,
        })
        .then((res) => {
          loading.close();
          console.log("res", res);
          if (res.code != 0) {
            this.$message.warning(res.msg);
            return;
          }
          if (res.data) {
            window.open(res.data);
          }
        });
    },
    async showInvoice() {
      if (this.detail.paymentRecordBoList && this.detail.paymentRecordBoList.length > 0) {
        //校验付款人和签署协议人是一个人
        const boIdList = this.detail.paymentRecordBoList.map((item) => {
          return item.boId;
        });
        console.log("paymentRecordBoList boIdList: ", boIdList);
        const { data } = await getUser();
        if (!boIdList.includes(data.idStr)) {
          this.$message({
            message: `请联系付款人[${this.detail.paymentRecordBoList[0].realNameAndPhone}]开具发票`,
            type: "warning",
            duration: 5000,
          });
          return;
        }
      }
      // 查询开票等设置
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });
      this.$store
        .dispatch("orderTo/index/selInvoiceContractType", {
          orderId: this.orderId,
        })
        .then(async (res) => {
          console.log("res", res);
          if (res.code == 0 && res.data) {
            this.invoiceInfo = res.data;
            this.isZzInvoice = res.data.isZzInvoice;
            this.contractName = res.data.contractName;
            this.invoiceContractType = res.data.invoiceContractType;
            this.notCheckInvoiceBtnTips = "请勾选同意" + this.contractName;
            if (res.data.taxpayerType && res.data.taxpayerType == "QY") {
              this.form.nameDisabled = true;
              this.form.invoicetitleType = res.data.taxpayerType;
              this.changeTypeCheck();
              this.form.name = res.data.name;
              this.form.code = res.data.taxpayerNumber;
              this.form.addr = res.data.addr;
              this.form.tel = res.data.registerPhone;
            } else {
              const { code, data } = await requestApi.post(`sctrading/order/orderinvoice/sel`, {});
              if (code == "0" && data && data[0]) {
                const { issueType, type, invoicetitleType, receipt, taxRegistrationNumber, companyAddr, companyTel, bankOfDeposit, bankAccount } = data[0];
                this.form.issueType = issueType;
                this.form.type = type;
                this.form.invoicetitleType = invoicetitleType;
                if (invoicetitleType == "QY") {
                  this.changeTypeCheck();
                }
                this.form.name = receipt;
                this.form.code = taxRegistrationNumber;
                this.form.addr = companyAddr;
                this.form.tel = companyTel;
                this.form.bankName = bankOfDeposit;
                this.form.bankCode = bankAccount;
              }
              loading.close();
            }
          } else {
            loading.close();
          }
          await this.fetchBasicCaAgreement();
          loading.close();
          this.dialogFormVisible = true;
        });
    },
    confirmForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 需要签署合同，但是未实名
          if (this.invoiceContractType && (this.form.invoicetitleType === "QY" || this.form.type === "ZZSZYFP") && !this.detail.payMemberAuthStatus) {
            this.$confirm("用户未认证无法完成签署", "提示", {
              confirmButtonText: "去认证",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                window.open(`${process.env.VUE_APP_JR}v/accountAsset/balance/entBindCard?retUrl=${window.location.href}`);
              })
              .catch(() => {});
            return;
          }
          const loading = this.$loading({
            lock: false,
            text: "处理中...",
          });
          console.log("this.form: ", this.form);
          let orderInvoice = {
            issueType: this.form.issueType,
            receipt: this.form.name,
            type: this.form.type,
            invoicetitleType: this.form.invoicetitleType,
            taxRegistrationNumber: this.form.code,
            bankAccount: this.form.bankCode,
            bankOfDeposit: this.form.bankName,
            companyAddr: this.form.addr,
            companyTel: this.form.tel,
          };
          let requestObj = {
            orderId: this.orderId,
            orderInvoice: orderInvoice,
          };
          this.$store.dispatch("orderTo/index/addBillTaxpayInfo", requestObj).then((res) => {
            console.log("res", res);
            if (res.code === "0") {
              this.$message.success("操作成功");
              window.location.href = `/v/order/detail/${this.orderId}`;
            } else {
              this.$message.warning(res.msg);
            }
            loading.close();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancleForm() {
      this.dialogFormVisible = false;
      this.invoiceOpenZZ();
    },
    changeTypeCheck() {
      if (this.form.type === "PTFP" && this.form.invoicetitleType === "GR") {
        this.viewShow = false;
        this.titleShow = true;
        this.invoiceRule = JSON.parse(JSON.stringify(this.rules));
        this.invoiceQyAddrTip = "选填";
        this.invoiceQyTelTip = "选填";
        this.invoiceQyBankTip = "选填";
        this.invoiceQyBankNoTip = "选填";
      }
      if (this.form.type === "PTFP" && this.form.invoicetitleType === "QY") {
        this.viewShow = true;
        this.titleShow = true;
        this.invoiceRule = JSON.parse(JSON.stringify(this.rulesInvoiceQyType));
        this.invoiceQyAddrTip = "请输入企业地址";
        this.invoiceQyTelTip = "请输入企业电话";
        this.invoiceQyBankTip = "选填";
        this.invoiceQyBankNoTip = "选填";
      }
      if (this.form.type === "ZZSZYFP") {
        this.viewShow = true;
        this.titleShow = false;
        this.invoiceRule = JSON.parse(JSON.stringify(this.rulesInvoiceType));
        this.form.invoicetitleType = "QY";
        this.invoiceQyAddrTip = "请输入企业地址";
        this.invoiceQyTelTip = "请输入企业电话";
        this.invoiceQyBankTip = "请输入开户银行";
        this.invoiceQyBankNoTip = "请输入银行账号";
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
      console.log("this.form: ", this.form);
    },
    loadOrder() {
      this.queryOrderDetail();
    },
    /**
     * 查询预订单操作记录
     *
     * @param busType 业务类型
     * @Auther SongYapeng
     * @Date 2026/6/11
     */
    async selPreOrderOperationRecord(busType) {
      try {
        const { code, data } = await requestApi.post("scbasic/operation/operationrecord/selOperationRecordListByParam", {
          busId: this.orderId,
          busType,
        });
        // 取集合最后一条作为最新记录
        if (code === "0" && data && data.length > 0) {
          return data[data.length - 1];
        }
      } catch (e) {
        console.error("selPreOrderOperationRecord error", e);
      }
      return null;
    },
    /**
     * 加载预订单入库通知和验收信息
     *
     * @Auther SongYapeng
     * @Date 2026/6/11
     */
    async loadPreOrderOperationRecords() {
      const [noticeOperationRecord, acceptanceOperationRecord] = await Promise.all([
        this.selPreOrderOperationRecord("YDD_NOTICE_TEMPLATE_MERCHANT"),
        this.selPreOrderOperationRecord("YDD_NOTICE_TEMPLATE_BUYER"),
      ]);
      this.noticeOperationRecord = noticeOperationRecord;
      this.acceptanceOperationRecord = acceptanceOperationRecord;
    },
    queryOrderDetail() {
      let loadingInstance1 = Loading.service({ fullscreen: true });
      this.$store
        .dispatch("orderTo/index/selOrderDetailByOrderId", {
          orderId: this.orderId,
          reqTimestamp: this.reqTimestamp,
          reqSystemId: this.reqSystemId,
          accessToken: this.accessToken,
        })
        .then((data) => {
          if (data) {
            this.detail = data;
            if (this.showAddInvoice && !this.detail.isReceipt) {
              this.showInvoice();
            }
            this.orderGoodsGiftBoList = data.orderGoodsGiftBoList || [];
            // 预订单加载入库通知和验收操作记录
            if (data.orderDtlBo && data.orderDtlBo.orderType == 4) {
              this.loadPreOrderOperationRecords();
            }
            Promise.all([
              this.$store.dispatch("orderTo/index/selButtonDetailByOrderId", {
                orderId: this.orderId,
                reqTimestamp: this.reqTimestamp,
                reqSystemId: this.reqSystemId,
                accessToken: this.accessToken,
              }),
              this.$store.dispatch("orderTo/index/selDeliveryDetailByOrderId", {
                orderId: this.orderId,
                reqTimestamp: this.reqTimestamp,
                reqSystemId: this.reqSystemId,
                accessToken: this.accessToken,
              }),
              this.$store.dispatch("orderTo/index/selOrderGoodsListByOrderId", { orderId: this.orderId }),
              this.$store.dispatch("orderTo/index/selOrderCredentialByOrderId", {
                orderId: this.orderId,
                reqTimestamp: this.reqTimestamp,
                reqSystemId: this.reqSystemId,
                accessToken: this.accessToken,
              }),
              this.selMemberVehicleList(),
            ]).then(([res1, res2, res3, res4]) => {
              this.buttonList = res1 || [];
              this.showContractButton = this.buttonList.some((item) => item.buttonCode === "to_read_contract");
              if (this.accessToken) {
                this.buttonList = [];
              }
              this.orderDelivery = res2;
              this.orderGoodsList = res3;
              this.orderGoodsList.forEach((item) => {
                if (item.cfyCard == 1) {
                  this.cfyCard = item.cfyCard;
                }
              });
              this.orderCredential = res4;
              if (this.orderCredential && this.orderCredential.resList && this.orderCredential.resList.length > 0) {
                this.orderCredentialList = this.orderCredential.resList;
              }
              if (this.orderCredential && this.orderCredential.imgList && this.orderCredential.imgList.length > 0) {
                this.auditCredentialImgList = this.orderCredential.imgList;
              }
              console.log("item.cfyCard", this.cfyCard);
              console.log("this.orderCredentialList", this.orderCredentialList);
              this.loaded = true;
              loadingInstance1.close();
            });
          }
        });
    },
    selMemberVehicleList() {
      this.$store.dispatch("orderTo/index/selMemberVehicleList", { searchText: "" }).then((data) => {
        this.orderVehicleList = data;
      });
    },
    buttonSubmit(item, order) {
      console.log("buttonSubmit", item, order);
      let quantityTimer = null;
      let count = 0;
      switch (item.buttonCode) {
        case "to_pay_juge_contract":
          loading = this.$loading({
            lock: false,
            text: "加载中...",
          });
          quantityTimer = setInterval(() => {
            this.$store.dispatch("orderTo/index/selOrderToPayByOrderId", { orderId: order.orderId }).then((data) => {
              console.log("selOrderToPayByOrderId：", data);
              if (data && data.isToPay) {
                clearInterval(quantityTimer);
                loading.close();
                console.log("selOrderToPayByOrderId退出循环");
                this.handlerOrderToPayByOrderId(data, order.orderId);
              } else {
                count++;
                if (count > 10) {
                  clearInterval(quantityTimer);
                  loading.close();
                  console.log("count >10", count);
                  this.$message.error(item.buttonMsg);
                }
              }
            });
          }, 500);
          return;
        case "to_multiple_pay_by_gray_setting":
          this.$message.error(item.buttonMsg);
          return;
        case "to_multiple_pay_by_confirm":
          this.$message.error(item.buttonMsg);
          return;
        case "to_multiple_pay":
          window.open(`${process.env.VUE_APP_APP}order/person/toOrderFractionalPayment?orderId=${order.orderId}&type=1`);
          return;
        case "to_pay_by_gray_setting":
          this.$message.error(item.buttonMsg);
          return;
        case "to_pay_by_confirm":
          this.$message.error(item.buttonMsg);
          return;
        case "to_pay":
          this.selOrderToPayByOrderId(order.orderId);
          return;
        case "to_pay_by_finance":
          // https://jr.t.nxin.com/nfd/pc/sytpay/payContinue.shtml?orderNum=xxxx
          this.openOrderToPayBox("如果没弹出支付页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已支付完成", "遇到问题，重试");
          window.open(`${process.env.VUE_APP_JR}nfd/pc/sytpay/payContinue.shtml?orderNum=${order.orderId}`);
          return;
        case "to_sign_contract":
          this.$store.dispatch("orderTo/index/signContract", { orderId: order.orderId }).then((res) => {
            if (res && res.code) {
              this.$refs.contract_sign_dialog.getContractData(order.orderId, false, { ...order, buildContractVisible: true }, true);
            } else {
              this.$message.error("订单:" + order.orderId + "，电子合同属性设置不完整，根据法律规定，无法签署合同，请完善电子合同属性后，再进行签署。");
            }
          });
          return;
        case "to_read_contract":
          this.$refs.contract_sign_dialog.viewContract(item);
          //window.open(`${process.env.VUE_APP_APP}contract/toEcontrantDetail?id=${item.contractId}&isBuyer=2`);
          return;
        case "to_sign_material":
          window.open(
            // eslint-disable-next-line max-len
            `${process.env.VUE_APP_APP}contract/toSignMaterialConfirmation?orderId=${order.orderId}&returnUrl=${window.location.href}`
          );
          return;
        case "to_read_material":
          window.open(
            // eslint-disable-next-line max-len
            `${process.env.VUE_APP_APP}contract/toMaterialConfirmationDetail?id=${order.orderId}&isBuyer=1`
          );
          return;
        case "to_cancel_by_confirm":
          this.$message.error(item.buttonMsg);
          return;
        case "to_cancel":
          this.$confirm("确定取消订单吗", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$store.dispatch("orderTo/index/cancelOrder", { orderId: order.orderId }).then((res) => {
                if (res.success) {
                  this.$message("取消成功");
                  this.queryOrderDetail();
                } else {
                  this.$message.error(res.errormsg);
                }
              });
            })
            .catch(() => {});
          return;
        case "to_order_del":
          this.$confirm("确定删除订单吗", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$store.dispatch("orderTo/index/delOrder", { orderId: order.orderId }).then((res) => {
                this.$message(res.message);
                this.queryOrderDetail();
              });
            })
            .catch(() => {});
          return;
        case "to_buy_again":
          this.$store.dispatch("orderTo/index/orderBuyAgain", { orderId: order.orderId }).then((res) => {
            if (res && res.success) {
              if (res.errormsg) {
                this.$message.error(res.errormsg);
              }
              window.open(`${process.env.VUE_APP_APP}cart/selectCart`);
            } else if (res && res.errorcode && res.errorcode == "1000") {
              window.open(`${process.env.VUE_APP_WEB_QLW}appmrket/shopjump?t=p&id=${res.data}`);
            } else {
              this.$message.error(res.errormsg);
            }
          });
          return;
        case "to_apply_refund":
          this.$store.dispatch("orderTo/index/orderRefund", { orderId: order.orderId }).then((res) => {
            if (res.code == 0) {
              window.open(`${process.env.VUE_APP_APP}order/person/toApplyRefund?orderId=${order.orderId}`);
            } else {
              this.$message.error(res.msg);
            }
          });
          return;
        case "to_read_refund":
          window.open(
            // eslint-disable-next-line max-len
            `${process.env.VUE_APP_APP}v/aftersales/detail/${item.refundOrderId}?type=buyer&orderId=${order.orderId}`
          );
          return;
        case "to_remind_shipment":
          this.$store.dispatch("orderTo/index/orderRemindShipment", { orderId: order.orderId }).then(() => {
            this.$message("提醒发送成功");
          });
          return;
        case "to_delivery_goods":
          const voucherPicList = [];
          if (this.detail.buyerVoucherPicList.length == 0 && this.detail.sellerVoucherPicList.length > 0) {
            this.detail.sellerVoucherPicList.forEach((sellerVoucher) => {
              let url = sellerVoucher.url;
              let acUrl = url;
              const isZip = /(zip)$/.test(acUrl);
              let logoUrl = "";
              if (isZip) {
                logoUrl = "https://files.nxin.com/mobile/public/zip.png";
                url = logoUrl;
              }
              const voucher = {
                name: "",
                url: url || "",
                acUrl: acUrl,
              };
              voucherPicList.push(voucher);
            });
          }
          this.$refs.order_buyer_dialog.toDeliveryGoodsOpen(item, this.buyerVoucherPicList.length, voucherPicList, this.detail.delivery);
          return;
        case "to_order_logistic":
          window.open(`${process.env.VUE_APP_APP}order/person/orderDeliver?orderId=${order.orderId}&type=1`);
          return;
        case "to_order_valuation":
          window.open(`${process.env.VUE_APP_APP}v/comment/add?isShowTitle=1&orderId=${order.orderId}`);
          return;
        case "to_order_review":
          window.open(`${process.env.VUE_APP_APP}v/comment/comment?isShowTitle=1&orderId=${order.orderId}`);
          return;
        case "to_order_edit_delivery_addr":
          this.$refs.order_buyer_dialog.toEditDelivery(order.orderId);
          return;
        case "to_order_edit_self_pickup_addr":
          this.$refs.order_buyer_dialog.toEditSelfPickupDelivery(order.orderId);
          return;
        case "to_behalf_purchase_pick_up_buyer":
          window.open(`${process.env.VUE_APP_APP}shopInfo/shopInfoList.do?shopId=${order.shopId}`);
          return;
        case "to_add_invoice_buyer":
          this.showInvoice();
          return;
        case "to_pick_up_yyd_buyer":
          preOrdergenerate(
            {
              cartItemReqFormList: this.orderGoodsList.map((item) => ({
                fromShopId: item.shopId,
                quantity: item.goodsQuantity,
                skuId: item.goodsId,
              })),
              vueThis: this,
              relationOrderId: this.detail.orderId,
            }
          )
          return;
        default:
          this.$message.error("无效按钮");
          return;
      }
    },
    vehicleAddOpen() {
      this.vehicleForm.name = "";
      this.vehicleForm.licensePlateNum = "";
      this.vehicleForm.tel = "";
      this.vehicleForm.idCard = "";
      this.vehicleAddDialogVisible = true;
    },
    vehicleFormSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch("comCart/addVehicle", this.vehicleForm).then((res) => {
            console.log(res);
            if (res.code === "0") {
              this.$message.success("添加成功！");
              this.$refs[formName].resetFields();
              this.vehicleAddDialogVisible = false;
              this.selMemberVehicleList();
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    orderVehicleChange(id) {
      this.thisVehicleChangeId = id;
      this.checkCartDialogVisible = true;
    },
    checkCartEdit(item) {
      this.detail.orderDtlBo.orderBuyerVehicleList = [];
      let vehicleData = {
        name: item.name,
        tel: item.tel,
        vehicleId: item.id,
        waybillId: "",
        licensePlateNum: item.licensePlateNum,
        idCard: item.encryptionIdCard,
      };
      this.detail.orderDtlBo.orderBuyerVehicleList.push(vehicleData);
      this.$store
        .dispatch("orderTo/index/updateOrderVehicleByList", {
          orderId: this.orderId,
          orderVehicleAttrStr: JSON.stringify(this.detail.orderDtlBo.orderBuyerVehicleList),
        })
        .then((data) => {
          console.log("data", data);
          this.$message({
            message: "自提车辆已更新",
            type: "warning",
          });
        });
      this.checkCartDialogVisible = false;
    },
    orderVehicleDel(id, index) {
      if (this.detail.orderDtlBo.orderBuyerVehicleList.length == 1 && this.detail.isOrderVehicle == 1) {
        this.$message({
          message: "该笔订单至少存在一辆自提车辆！",
          type: "warning",
        });
        return;
      }
      this.detail.orderDtlBo.orderBuyerVehicleList.splice(index, 1);
      this.$store
        .dispatch("orderTo/index/delOrderWaybillById", {
          orderId: this.orderId,
          vehicleId: id,
        })
        .then((data) => {
          console.log("data", data);
        });
      this.$store
        .dispatch("orderTo/index/addOrderVehicleByList", {
          orderId: this.orderId,
          orderVehicleAttrStr: JSON.stringify(this.detail.orderDtlBo.orderBuyerVehicleList),
        })
        .then((data) => {
          console.log("data", data);
        });
    },
    orderVehicleAddOpen() {
      this.addCartList = [];
      this.addCartDialogVisible = true;
    },
    handleAddCartChange(val) {
      this.addCartList = val;
    },
    selectCartDisable(row) {
      let selectCart = true;
      this.detail.orderDtlBo.orderBuyerVehicleList.forEach((item) => {
        if (item.vehicleId === row.id) {
          selectCart = false;
        }
      });
      return selectCart;
    },
    removeSelectCart() {
      this.$refs.orderVehicleTable.clearSelection();
      this.addCartDialogVisible = false;
    },
    saveSelectCart() {
      if (this.detail.orderDtlBo.orderBuyerVehicleList.length + this.addCartList.length == 0) {
        this.$message({
          message: "该笔订单至少存在一辆自提车辆！",
          type: "warning",
        });
        return;
      }
      /*if (this.detail.isSelfOperated == 1 || this.detail.purchaseOrderId != "") {
        if (this.detail.orderDtlBo.orderBuyerVehicleList.length + this.addCartList.length > 1) {
          this.$message({
            message: "该笔订单只能选择一辆自提车辆！",
            type: "warning",
          });
          return;
        }
      }*/
      this.addCartList.forEach((item) => {
        let vehicleData = {
          name: item.name,
          tel: item.tel,
          vehicleId: item.id,
          waybillId: "",
          licensePlateNum: item.licensePlateNum,
          idCard: item.idCard,
        };
        this.detail.orderDtlBo.orderBuyerVehicleList.push(vehicleData);
      });
      this.$store
        .dispatch("orderTo/index/addOrderVehicleByList", {
          orderId: this.orderId,
          orderVehicleAttrStr: JSON.stringify(this.detail.orderDtlBo.orderBuyerVehicleList),
        })
        .then((data) => {
          console.log("data", data);
        });
      this.addCartDialogVisible = false;
    },
    delBuyerVoucherMap(voucherMap) {
      this.$confirm("是否确认删除凭证？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          voucherMap.voucherPicList.forEach((item) => {
            this.$store
              .dispatch("orderTo/index/delOrderVoucherById", {
                id: item.id,
              })
              .then(async (res) => {
                console.log("delOrderVoucherById", res);
                if (uuidStr) {
                  await requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/del`, {
                    key: uuidStr,
                    val: "https://nfs.nxin.com/d6b5b4589d464682b51a6eeb77a03b3d.png",
                  });
                }
              });
          });
          this.queryOrderDetail();
        })
        .catch(() => {
          return;
        });
    },
    delBuyerVoucher(id) {
      this.$confirm("是否确认删除凭证？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store
            .dispatch("orderTo/index/delOrderVoucherById", {
              id: id,
            })
            .then(async (res) => {
              console.log("delOrderVoucherById", res);
              if (uuidStr) {
                await requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/del`, {
                  key: uuidStr,
                  val: "https://nfs.nxin.com/d6b5b4589d464682b51a6eeb77a03b3d.png",
                });
              }
              this.queryOrderDetail();
            });
        })
        .catch(() => {
          return;
        });
    },
    // 上传图片之前
    uploadBefore(file) {
      const { size, name } = file;

      if (size == 0) {
        this.$message.warning('不能上传空文件');
        return false;
      }

      // 获取文件扩展名
      const fileExtension = name.substring(name.lastIndexOf('.')).toLowerCase();

      // 允许的文件扩展名
      const allowedExtensions = ['.jpg', '.jpeg', '.png', '.bmp', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.zip'];

      // 最大文件大小 50MB
      const maxSize = 50 * 1024 * 1024;

      // 验证文件类型
      if (!allowedExtensions.includes(fileExtension)) {
        this.$message.warning('上传文件格式不正确，支持格式：JPG/JPEG/PNG/BMP/PDF/DOC/DOCX/XLS/XLSX/ZIP');
        return false;
      }

      // 验证文件大小
      if (size > maxSize) {
        this.$message.warning('上传文件大小不能超过 50MB');
        return false;
      }

      return true;
    },
    // 上传图片成功之后
    uploadVoucherSuccess(response, file, fileList) {
      // 等全部完成才处理
      console.log("fileList", fileList);
      if (fileList.every((item) => (item.response && item.response.code == 0) || item.acUrl)) {
        this.buyerVoucherPicList = fileList.map((item) => {
          if (item.response) {
            let { name, url } = item.response.data;
            let acUrl = url;
            let logoUrl = "";
            if (this.isZip(name)) {
              logoUrl = "https://files.nxin.com/mobile/public/zip.png";
              url = logoUrl;
            }
            if (this.isWord(name)) {
              logoUrl = "https://files.nxin.com/mobile/public/word.png";
              url = logoUrl;
            }
            if (this.isPdf(name)) {
              logoUrl = "https://files.nxin.com/mobile/public/pdf.png";
              url = logoUrl;
            }
            if (this.isExcel(name)) {
              logoUrl = "https://files.nxin.com/mobile/public/excel.png";
              url = logoUrl;
            }
            return {
              name: name || "",
              url: url || "",
              acUrl: acUrl || "",
            };
          }
          return item;
        });

        console.log("this.buyerVoucherPicList", this.buyerVoucherPicList);
      }
    },
    // 删除图片
    async uploadVoucherRemove(file, fileList) {
      console.log("file", file);
      if (uuidStr) {
        await requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/del`, {
          key: uuidStr,
          val: file.url,
        });
      }

      this.buyerVoucherPicList = fileList;
    },
    // 上传图片限制
    uploadVoucherExceed() {
      console.log("buyerVoucherPicList", this.buyerVoucherPicList.length);
      this.$message.warning("最多上传30张图片");
    },
    async submitBuyerVoucher() {
      if (this.submitBuyerVoucherLoading) {
        return;
      }
      if (this.buyerVoucherPicList.length == 0) {
        this.$message.warning("请上传文件");
        return;
      }
      let orderVoucher = [];
      let orderVoucherNot = [];
      let promiseList = [];
      let promiseArgList = [];
      this.buyerVoucherPicList.forEach((item) => {
        let acUrl = item.acUrl;
        let url = item.url;
        if (acUrl) {
          url = acUrl;
        }
        let voucher = {
          fileType: "ORDER_VOUCHER_PICTURE",
          busType: "BUYER",
          refId: this.orderId,
          url: url,
        };
        promiseList.push(this.$store.dispatch("orderTo/index/checkUploadOrderVoucher", { orderId: this.orderId, voucherImgUrl: url }));
        promiseArgList.push(voucher);
      });

      this.submitBuyerVoucherLoading = true;
      const resArr = await Promise.all(promiseList);
      resArr.forEach((res, index) => {
        console.log("res==", res);
        if (res.code == "0") {
          orderVoucher.push(promiseArgList[index]);
        } else {
          orderVoucherNot.push(promiseArgList[index]);
        }
      });

      if (orderVoucher.length == 0 && orderVoucherNot.length > 0) {
        this.$message.warning("存在不符合要求的图片，请上传提货单或司机相关图片");
        this.submitBuyerVoucherLoading = false;
        return;
      }
      if (orderVoucherNot.length > 0) {
        this.submitBuyerVoucherLoading = false;
        this.$confirm("存在不符合要求的凭证，如继续上传将自动删除不符合要求的凭证，是否确认上传？", "提示", {
          confirmButtonText: "确认上传",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.addOrderVoucherSubmit(orderVoucher);
          })
          .catch(() => {
            return;
          });
        return;
      }
      this.addOrderVoucherSubmit(orderVoucher);
    },
    addOrderVoucherSubmit(orderVoucher) {
      this.$store.dispatch("orderTo/index/addOrderVoucherList", { fileList: orderVoucher }).then((res) => {
        this.submitBuyerVoucherLoading = false;
        if (res.code == "0") {
          this.$message.success("上传成功");
          this.buyerVoucherPicList = [];
          this.$refs.uploadVoucher.clearFiles();
          this.queryOrderDetail();
        } else {
          this.$message.warning("上传失败");
        }
      });
    },
    // 上传图片成功之后
    uploadCfyVoucherSuccess(res) {
      console.log("上传图片成功之后", res);
      const {
        data: { name, url },
      } = res;
      const item = {
        name: name || "",
        url: url || "",
      };
      console.log("item", item);
      this.buyerCfyVoucherPicList.push(item);
    },
    // 删除图片
    uploadCfyVoucherRemove(file, fileList) {
      this.buyerCfyVoucherPicList = fileList;
    },
    // 上传图片限制
    uploadCfyVoucherExceed() {
      this.$message.warning("最多上传30张图片");
    },
    submitBuyerCfyVoucher() {
      if (this.buyerCfyVoucherPicList.length == 0) {
        this.$message.warning("请上传文件");
        return;
      }
      let orderVoucher = [];
      this.buyerCfyVoucherPicList.forEach((item) => {
        let voucher = {
          fileType: "ORDER_VOUCHER_PICTURE",
          busType: "CFY_BUYER",
          refId: this.orderId,
          url: item.url,
        };
        orderVoucher.push(voucher);
      });
      this.$store.dispatch("orderTo/index/addOrderVoucherList", { fileList: orderVoucher }).then((res) => {
        console.log("addOrderVoucherList", res);
        if (res.code == "0") {
          this.$message.success("上传成功");
          this.buyerCfyVoucherPicList = [];
          this.queryOrderDetail();
        } else {
          this.$message.warning("上传失败");
        }
      });
    },
    selOrderToPayByOrderId(orderId) {
      this.$store.dispatch("orderTo/index/selOrderToPayByOrderId", { orderId: orderId }).then((data) => {
        this.handlerOrderToPayByOrderId(data, orderId);
      });
    },

    handlerOrderToPayByOrderId(data, orderId) {
      if (!data.isAllowPayment) {
        this.$message.error("您没有支付权限");
        return;
      }
      // 签署代付协议
      if (data.isBuildPaymentOnBehalfTreaty == "1") {
        this.$confirm("您正在替其他用户或企业支付该笔订单，请签署相关代付协议后再支付？", "提示", {
          confirmButtonText: "签署",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.openOrderToPayBox("如果没弹出签署页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已完成签署", "遇到问题，重试");
            window.open(`${process.env.VUE_APP_APP}v/treaty/paymentOnBehalfTreaty?isShowTitle=1&orderId=${orderId}`);
          })
          .catch(() => {});
        return;
      }
      // 个人认证
      if (data.isBuildPaymentOnBehalfTreaty == "2") {
        this.$confirm("您正在替其他用户或企业支付该笔订单，请先进行实名认证后再支付？", "提示", {
          confirmButtonText: "去认证",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.openOrderToPayBox("如果没弹出认证页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已完成认证", "遇到问题，重试");
            window.open(`${process.env.VUE_APP_JR}yue_openAccount_auth.html?retUrl=${window.location.href}`);
          })
          .catch(() => {});
        return;
      }
      // 企业认证
      if (data.isBuildPaymentOnBehalfTreaty == "3") {
        this.$confirm("您正在替其他用户或企业支付该笔订单，请先进行实名认证后再支付？", "提示", {
          confirmButtonText: "去认证",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.openOrderToPayBox("如果没弹出认证页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已完成认证", "遇到问题，重试");
            window.open(`${process.env.VUE_APP_JR}yueOrgRegister.html?retUrl=${window.location.href}`);
          })
          .catch(() => {});
        return;
      }
      if (data.isBuildPaymentOnBehalfTreaty == "4") {
        this.$message.error("下单用户或企业未完成实名认证，您无法替该用户或企业支付该笔订单");
        return;
      }

      if (!data.isToPay) {
        this.$message.error(data.isToPayMsg);
        return;
      }
      this.openOrderToPayBox("如果没弹出支付页面，可能被您的浏览器拦截了！请检查浏览器设置", "我已支付完成", "遇到问题，重试");
      window.open(`${process.env.VUE_APP_APP}payment/chectout/bkCheckout/${orderId}`);
    },

    openOrderToPayBox(msg, confirmButtonText, cancelButtonText) {
      const h = this.$createElement;
      this.$msgbox({
        title: "消息",
        message: h("p", null, [h("span", null, msg)]),
        showCancelButton: true,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            console.log("openOrderToPayBox", action);
          }
          done();
          this.searchForm.pageNum = 1;
          this.selBuyerOrderListByParam();
        },
      }).then(() => {});
    },
    async imgTransfer() {
      this.signatureDialogVisible = true;
      uuidStr = uuid();
      setTimeout(() => {
        QrCode.toCanvas(this.$refs.qrCodeCanvas, `${process.env.VUE_APP_static}imgTransfer/batch.html?uuid=${uuidStr}`);
      }, 100);

      imgTransferTimer && clearInterval(imgTransferTimer);
      imgTransferTimer = setInterval(async () => {
        const { data } = await requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/sel`, {
          key: uuidStr,
        });
        if (this.buyerVoucherPicList && this.buyerVoucherPicList.length >= 30) {
          clearInterval(imgTransferTimer);
          this.$message.error("已达上传最大量");
          return;
        }
        data.valList.forEach((url) => {
          if (!this.buyerVoucherPicList.some((item) => item.url == url)) {
            this.buyerVoucherPicList.push({
              name: url.substring(0, url.lastIndexOf(".")),
              url,
            });
          }
        });
        console.log("this.buyerVoucherPicList", this.buyerVoucherPicList);
      }, 2000);
    },
    isZip(fileUrl) {
      // 后缀获取
      let suffix = "";
      try {
        let fileArr = fileUrl.split(".");
        suffix = fileArr[fileArr.length - 1];
      } catch (err) {
        suffix = "";
        return false;
      }
      return suffix === "zip";
    },

    isPdf(fileUrl) {
      // 后缀获取
      let suffix = "";
      try {
        let fileArr = fileUrl.split(".");
        suffix = fileArr[fileArr.length - 1];
      } catch (err) {
        suffix = "";
        return false;
      }
      return suffix === "pdf";
    },

    isWord(fileUrl) {
      // 后缀获取
      let suffix = "";
      try {
        let fileArr = fileUrl.split(".");
        suffix = fileArr[fileArr.length - 1];
      } catch (err) {
        suffix = "";
        return false;
      }

      return suffix === "doc" || suffix === "docx";
    },
    isExcel(fileUrl) {
      // 后缀获取
      let suffix = "";
      try {
        let fileArr = fileUrl.split(".");
        suffix = fileArr[fileArr.length - 1];
      } catch (err) {
        suffix = "";
        return false;
      }
      return suffix === "xls" || suffix === "xlsx";
    },
    auditCredentialRecord(data, status) {
      console.log("auditCredentialRecord.data: ", data);
      console.log("auditCredentialRecord.status: ", status);
      let confirmMsg = "确定审核通过提货凭证？";
      let title = "审核通过";
      if (status == 2) {
        confirmMsg = "驳回后，需要通知用户再次上传提货凭证。确认驳回么？";
        title = "审核驳回";
      }
      this.$confirm(confirmMsg, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store
            .dispatch("orderTo/index/auditOrderCredentialById", {
              id: data.id,
              approvalStatus: status,
              reqTimestamp: this.reqTimestamp,
              reqSystemId: this.reqSystemId,
              accessToken: this.accessToken,
            })
            .then((res) => {
              if (res.code == "0") {
                this.$message.success("操作成功");
                this.queryOrderDetail();
              } else {
                this.$message.warning(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    // 选择电子发票
    invoiceInput(type) {
      if (type == "DZ" && this.invoiceInfo && this.invoiceInfo.isZxInvoice) {
        this.invoiceOnLine = true;
      } else {
        this.invoiceOnLine = false;
      }
    },
    // 开纸质发票
    invoiceOpenZZ() {
      this.invoiceOnLine = false;
      this.form.issueType = "ZZ";
    },
    // 移动端开发票，刷新按钮
    invoiceRefresh() {
      window.location.href = `${window.location.origin}/v/order/detail/${this.orderId}`;
    },
    async contractPreviewHandle(relContId) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { code, msg, data } = await requestApi.post(`sctrading/contract/info/getContractUrl`, {
        relContId,
      });
      loading.close();

      if (code == "0") {
        this.contractPreviewUrl = data;
        this.contractPreviewVisible = true;
      } else {
        this.$message.error(msg);
      }
    },
    viewContract() {
      let item = {
        orderId: this.orderId,
      };
      this.$refs.contract_sign_dialog.viewContract(item);
    },
  },
};
